import { ReactElement, useCallback } from 'react';
import { noop } from 'lodash';

import { ActionEventInterceptor } from '@dreryk/react-components';

import { VisitSettlementControl } from '../../visitSettlement.types';

import { useVisitSettlementUpdateMedicalServicesCommand } from './medicalServices.hooks';

type VisitSettlementMedicalServicesUpdateEventInterceptorProps = {
   readonly control: VisitSettlementControl;
   readonly appointmentId: number;
   readonly blockingOperation?: boolean;
   readonly children: ReactElement;
};

// eslint-disable-next-line max-lines-per-function
export const VisitSettlementMedicalServicesUpdateEventInterceptor = (
   props: VisitSettlementMedicalServicesUpdateEventInterceptorProps
): JSX.Element => {
   const updateVisitSettlementMedicalServices = useVisitSettlementUpdateMedicalServicesCommand({
      control: props.control,
      appointmentId: props.appointmentId,
      blockingOperation: props.blockingOperation,
   });

   const action = useCallback(async () => {
      const dirty = Boolean(props.control.formState.dirtyFields.visitSettlement);
      if (!dirty) {
         return noop();
      }

      return updateVisitSettlementMedicalServices();
   }, [props.control, updateVisitSettlementMedicalServices]);

   return <ActionEventInterceptor action={action}>{props.children}</ActionEventInterceptor>;
};
